var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_c('Toolbar')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"backTop"}},[_c('i',{staticClass:"fa fa-arrow-up",attrs:{"aria-hidden":"true"}})])}]

export { render, staticRenderFns }